// extracted by mini-css-extract-plugin
export var body = "_mc-0";
export var sectionHeader = "_mc-4";
export var shortcutColumns = "_mc-2";
export var shortcutList = "_mc-1";
export var shortcutSection = "_mc-3";